import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BudgetSummarySectionModel } from '../../../../core/models/data/budget-summary.model';
import { CurrencyModel } from '../../../../core/models/data/currency.model';
import { CurrencyDisplayPipe } from '../../../../core/pipes/currency/currency.pipe';
import { BudgetSectionKind, BudgetUtilities } from '../../../../core/utilities/budget.utilities';

@Component({
  selector: 'ms-budget-summary-section',
  imports: [CommonModule, CurrencyDisplayPipe],
  templateUrl: './budget-summary-section.component.html',
  styleUrl: './budget-summary-section.component.scss',
})
export class BudgetSummarySectionComponent {

  public title = input.required<string>();
  public sectionKind = input.required<BudgetSectionKind>();
  public section = input<BudgetSummarySectionModel | undefined>(undefined);
  public currency = input<CurrencyModel | undefined>(undefined);
  public isLoading = input<boolean>(false);

  public varianceClass(variance: number): string {
    return BudgetUtilities.getVarianceColorClass(variance, this.sectionKind());
  }

  public variancePercentage(variance: number, budgeted: number): string {
    return BudgetUtilities.formatVariancePercentage(variance, budgeted);
  }
}
